import React from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

function AdminSideBar() {
  return (
    <div>
      <Link to="/admin">
        <div className="d-flex justify-content-center mb-3 bg-light">
          <i className="fas fa-home"></i>
        </div>
      </Link>
      <Nav variant="pills" className="flex-column">
        <Nav.Item>
          <Nav.Link as={Link} to="/admin/productos" eventKey="first" className="pointer">
            Productos
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={Link} to="/admin/categorias" eventKey="second" className="pointer">
            Categorias
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={Link} to="/admin/usuarios" className="pointer" eventKey="third">
            Usuarios
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={Link} to="/admin/ventas" className="pointer" eventKey="fourth">
            Ventas
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
}

export default AdminSideBar;
